import React, { useState } from "react";
import { toast } from "react-toastify";

const StockableExpiryPopup = ({ items, onClose, onConfirm }) => {
    const [dates, setDates] = useState({});
    const [errors, setErrors] = useState({});

    const handleChange = (index, value) => {
        setDates(prev => ({ ...prev, [index]: value }));

        setErrors(prev => ({ ...prev, [index]: false }));
    };

    const handleSubmit = () => {
        const newErrors = {};

        items.forEach((_, i) => {
            if (!dates[i]) {
                newErrors[i] = true;
            }
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            toast.error("Please fill all expiry dates");
            return;
        }

        onConfirm(dates);
    };

    const getDaysUntilExpiry = (dateStr) => {
        if (!dateStr) return null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const expiry = new Date(dateStr);
        expiry.setHours(0, 0, 0, 0);

        const diffMs = expiry - today;
        return Math.round(diffMs / (1000 * 60 * 60 * 24));
    };

    const formatExpiryLabel = (days) => {
        if (days === null) return null;

        if (days < 0) {
            return {
                text: `Expired ${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"} ago`,
                color: "text-red-600",
            };
        }
        if (days === 0) {
            return { text: "Expires today", color: "text-red-600" };
        }
        if (days <= 7) {
            return { text: `Expires in ${days} day${days === 1 ? "" : "s"}`, color: "text-amber-600" };
        }
        return { text: `Expires in ${days} day${days === 1 ? "" : "s"}`, color: "text-gray-500" };
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white p-4 rounded-md w-[400px]">
                <h3 className="font-semibold mb-3 text-lg">Enter Expiry Dates</h3>

                <div className="space-y-3">
                    {items.map((item, i) => {
                        const days = getDaysUntilExpiry(dates[i]);
                        const expiryLabel = formatExpiryLabel(days);

                        return (
                            <div key={i} className="flex flex-col gap-1">
                                <div className="flex justify-between items-center gap-2">
                                    <span className="text-sm">{item.ItemName}</span>
                                    <input
                                        type="date"
                                        value={dates[i] || ""}
                                        onChange={(e) => handleChange(i, e.target.value)}
                                        className={`border px-2 py-1 rounded w-40 ${errors[i] ? "border-red-500" : "border-gray-300"
                                            }`}
                                    />
                                </div>

                                {errors[i] && (
                                    <span className="text-sm font-semibold text-red-500">
                                        Expiry date is required
                                    </span>
                                )}

                                {!errors[i] && expiryLabel && (
                                    <span className={`text-sm text-right font-semibold ${expiryLabel.color}`}>
                                        {expiryLabel.text}
                                    </span>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div className="flex justify-end gap-3 mt-6 border-t pt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 text-sm font-medium transition-colors hover:bg-gray-50 hover:border-gray-400"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium transition-colors hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StockableExpiryPopup;